import { TabNavLink } from '@synoptic/ui-kit/tab-nav/tab-nav-link.tsx';
import { ComponentPropsWithoutRef } from 'react';
import { useLocation } from 'react-router';
import { Link } from '@/routes-utils/navigation.tsx';

export const TabLink = ({
  to,
  end,
  children,
  className,
  prefetch = 'intent',
  preventScrollReset,
  replace = true,
}: {
  to: string;
  end?: boolean;
  children: React.ReactNode;
  className?: string;
  prefetch?: ComponentPropsWithoutRef<typeof Link>['prefetch'];
  preventScrollReset?: boolean;
  replace?: boolean;
}) => {
  const pathname = useLocation().pathname;
  const toPath = to.split('?')[0];

  return (
    <TabNavLink
      active={end ? pathname === toPath : pathname.startsWith(toPath)}
      asChild
      className={className}
    >
      <Link
        to={to}
        prefetch={prefetch}
        replace={replace}
        preventScrollReset={preventScrollReset}
      >
        {children}
      </Link>
    </TabNavLink>
  );
};
